<div class="checkbox-container" [ngClass]="{'has-errors': hasErrors}">
  <boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames"
    (errorChange)="onErrorChange($event)">
  </boi-validation-error-generic>

  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div *ngIf="labelName" class="field-label">
        <div class="label-content">
          <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
        </div>
        <boi-tooltip *ngIf="showTooltip && !isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
        </boi-tooltip>
      </div>

      <div class="field-input">
        <input kendoCheckbox type="checkbox" [id]="controlId ? controlId : labelName" class="k-checkbox"
          [disabled]="isFieldDisabled" [(ngModel)]="isChecked" (ngModelChange)="updateCheckbox()">

        <span class="checkbox-label-wrapper">
          <label class="k-checkbox-label" [for]="controlId ? controlId : labelName" [innerHtml]="checkboxLabel"></label>

          <ng-container *ngIf="showTooltip && isTooltipLast">
            <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
          </ng-container>
        </span>
      </div>
    </div>
  </kendo-textbox-container>
</div>